import { gsap, Power4, Expo } from 'gsap'
import { CustomEase} from 'gsap/CustomEase'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { breakpointDown, breakpointUp } from '../utils/breakpoints'
import {Autoplay, Navigation, Swiper, Pagination, EffectFade} from "swiper";

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)



function startHeroSliderAnimation(){
  $('.js-hero-slider').each(function (i, el) {

    let swiper = new Swiper(el, {
      modules: [Autoplay, Navigation, Pagination, EffectFade],
      loop: true,
      effect: "fade",
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
      },
      speed: 600,
    })

  })

  gsap.fromTo('.js-hero-slider', {scale: 1.4},{scale: 1, duration: 1})
}


function initHeroSequence()
{
  if(breakpointDown('lg')) return

  let spinTimeline = gsap.timeline({
    force3D: false,
    scrollTrigger: {
      trigger: "#hero-sequence",
      scroller: ".smooth-scroll",
      pin: true,
      start: "top top",
      end: "+=100%",
      scrub: 1,
      //markers: true
    },
  })

  spinTimeline.fromTo('#hero-content-left .inner-content', {y: 0}, { y: '-100vh', duration: 1}, 0)
  spinTimeline.fromTo('#hero-content-right .inner-content', {y: '100vh'}, { y: 0, duration: 1, ease: 'none' }, 0)


}


let popupContents = ['.popup-modal-content.learn-more-apply', '.popup-modal-content.learn-more-who-is']
for (let i = 0;i < popupContents.length;i++) {

  let learnMore = $(popupContents[i])
  let lmaH1 = learnMore.find('h1').text()
  learnMore.find('h1').remove()
  let appendContent = '<h1>' + lmaH1 + '</h1>'
  learnMore.find('.column-right .text-content').prepend(appendContent)
}

export { initHeroSequence, startHeroSliderAnimation }

